import PropTypes from 'prop-types';

export const textInputPropTypes = {
  className: PropTypes.string,
  disableArrowUpDown: PropTypes.bool,
  hasError: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.node,
  numbersOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  optional: PropTypes.bool,
  optionalText: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  widthDefaultSpacing: PropTypes.bool,
};
